// "How My AI Knows It Already Said That" — cross-run novelty / dedup gate.
// Cold Compute / Neon kit. ~131s @ 30fps.
//
// Grounded in EAKC-MVP:
//   src/lib/skills/sources/novel-success-distillation.ts  (jaccardSimilarity, NOVELTY_THRESHOLD=0.3, 'not_novel')
//   supabase/migrations/171_mission_sent_ideas.sql        (cross-run "already shipped" memory)
//   src/lib/missions/orchestrator/contract/recent-sent-ideas.ts + render-prompt.ts  ("DO NOT re-pitch")
//   src/lib/workflows/compose-and-send-markdown-draft/index.ts  (isStaleResend byte-identical guard)
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames; contiguous (next.start = prev.start + prev.duration).
export const SCENE = {
  hook: { start: 0, duration: 150 }, //         0:00–0:05  same idea, 7 of 8 runs
  problem: { start: 150, duration: 540 }, //    0:05–0:23  recurring jobs spam the same output
  intuition: { start: 690, duration: 360 }, //  0:23–0:35  "have I said this already?"
  gate: { start: 1050, duration: 540 }, //      0:35–0:53  the novelty gate: accept / reject
  code: { start: 1590, duration: 780 }, //      0:53–1:19  jaccardSimilarity + 0.3 threshold
  reject: { start: 2370, duration: 420 }, //    1:19–1:33  not_novel → no LLM spend
  memory: { start: 2790, duration: 480 }, //    1:33–1:49  mission_sent_ideas: "do not re-pitch"
  payoff: { start: 3270, duration: 480 }, //    1:49–2:05  three layers, honest label
  outro: { start: 3750, duration: 330 }, //     2:05–2:16
} as const;

export const TOTAL_DURATION = 4080; // 136s

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
